import s from './RecommendedCategoryCard.module.css'

type Props = {
  category: string
  onClick: () => void
  dataId: string
}

const RecommendedCategoryCard = ({ category, onClick, dataId }: Props) => {
  return (
    <button className={s.wrapper} onClick={onClick} data-id={dataId}>
      <div title={category} className={s.category}>
        {category}
      </div>
    </button>
  )
}

export default RecommendedCategoryCard
